var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 99.46 117.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#343838"
  }, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#343838;}.cls-2{opacity:0.7;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6,.cls-7,.cls-8{opacity:0.6;}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 11.52,
    y1: 116.33,
    x2: 11.52,
    y2: 90.89,
    gradientUnits: "userSpaceOnUse",
    fill: "#343838"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343838",
    stopOpacity: 0,
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#343838",
    stopOpacity: 0.07,
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343838",
    stopOpacity: 0.3,
    fill: "#343838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 87.93,
    y1: 116.33,
    x2: 87.93,
    y2: 90.89,
    xlinkHref: "#linear-gradient",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 49.73,
    y1: 116.33,
    x2: 49.73,
    y2: 90.89,
    xlinkHref: "#linear-gradient",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 22.23,
    y1: 24.54,
    x2: 16.89,
    y2: 29.54,
    gradientUnits: "userSpaceOnUse",
    fill: "#343838"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00DFFC",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFFC",
    stopOpacity: 0,
    fill: "#343838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 98.64,
    y1: 24.54,
    x2: 93.3,
    y2: 29.54,
    xlinkHref: "#linear-gradient-4",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 68.65,
    y1: 1.09,
    x2: 63.27,
    y2: 8.12,
    xlinkHref: "#linear-gradient-4",
    fill: "#343838"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Company0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,23.2V90.37H23V23.2Zm16.61,54H6.43v-6.6H16.61Zm0-13.2H6.43v-6.6H16.61Zm0-13.2H6.43v-6.6H16.61Zm0-13.2H6.43V31H16.61Z",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.41,23.2V90.37h23V23.2ZM93,77.17H82.84v-6.6H93ZM93,64H82.84v-6.6H93Zm0-13.2H82.84v-6.6H93Zm0-13.2H82.84V31H93Z",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.65,9.45V90.37H39.83V77.17h19.8v13.2H69.81V0ZM46.43,64H36.25v-6.6H46.43Zm0-13.2H36.25v-6.6H46.43Zm0-13.2H36.25V31H46.43Zm0-13.2H36.25v-6.6H46.43ZM63.21,64H53v-6.6H63.21Zm0-13.2H53v-6.6H63.21Zm0-13.2H53V31H63.21Zm0-13.2H53v-6.6H63.21Z",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.43,117.65v-.88H16.61v.88H23V90.37H0v27.28Zm0-14.08H16.61v6.6H6.43Z",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.84,117.65v-.88H93v.88h6.43V90.37h-23v27.28Zm0-14.08H93v6.6H82.84Z",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "36.25 117.65 36.25 116.77 46.43 116.77 46.43 117.65 53.03 117.65 53.03 116.77 63.21 116.77 63.21 117.65 69.81 117.65 69.81 90.37 59.63 90.37 59.63 103.57 39.83 103.57 39.83 90.37 29.65 90.37 29.65 117.65 36.25 117.65",
    fill: "#343838"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "11.52 24.2 22.04 24.2 22.04 35.08 11.52 24.2",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "87.93 24.2 98.45 24.2 98.45 35.08 87.93 24.2",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "57.73 3.9 68.81 1.25 68.81 12.33 57.73 3.9",
    fill: "#343838"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyNew);
export default __webpack_public_path__ + "static/media/CompanyNew.44530776309fc40c42e18e43ba9d3dcc.svg";
export { ForwardRef as ReactComponent };